import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const InfoButton = ({ divClassName, header, content, popoverPlacement }) => {
  const popover = (
    <Popover className="text-dark px-xl-24 px-lg-16 py-xl-16 py-lg-8">
      <p className="mb-8 fw-600">{header}</p>
      <small className="fw-500">{content}</small>
    </Popover>
  );

  return (
    <div className={divClassName}>
      <OverlayTrigger trigger={['hover', 'focus']} overlay={popover} placement={popoverPlacement} rootClose>
        <Button className="btn-text text-gray-400 bg-transparent border-0 p-0">
          <FontAwesomeIcon icon={faInfoCircle} />
        </Button>
      </OverlayTrigger>
    </div>
  );
};

export default InfoButton;
